/* eslint-disable */
import React from 'react';


const Home = () => (
  <section id="home-id">
    <h1>Welcome to our Calculator app, you Math enthusiast!</h1>
    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse in ligula tortor. Aliquam fermentum enim ac turpis congue, sed accumsan lorem mollis. Pellentesque ultricies, sapien at porta tincidunt, erat turpis posuere ante, nec viverra tellus dolor nec velit. Aenean fringilla luctus purus, et interdum est rhoncus nec. Suspendisse eu dui a turpis dignissim aliquet. Aenean viverra ultrices lacinia. Fusce tristique nulla lectus, non bibendum risus commodo eget. Aliquam aliquam ipsum eget nisi lobortis porta. Donec ornare tortor elementum ex blandit pharetra.</p>
    <p>
      Vestibulum scelerisque tellus in lorem interdum, ac euismod enim bibendum. Aenean finibus odio vel sollicitudin aliquet. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Duis sodales pharetra vulputate. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
    </p>
  </section>
);
export default Home;